module.exports = __webpack_public_path__ + "img/montage1mini.bf7bfd99.webp";